export class CoolingUpdateLayout {
	public fields = [
		{ fieldName: 'coolingUpdateIndicator', label: 'Indicator' },
		{ fieldName: 'coolingUpdateType', label: 'Type' },
		{ fieldName: 'coolingUpdateTimeframe', label: 'Timeframe' },
		{ fieldName: 'coolingUpdateDescription', label: 'Description' }
	];
}
